import { RouterLink, RouterLinkActive } from '@angular/router';
import { Component, inject, OnInit } from '@angular/core';
import { addIcons } from 'ionicons';
import { add, bookOutline, bookSharp, book, lockClosed, informationCircle, peopleCircle, eye, business, checkmarkCircle, documentOutline, barcodeOutline, listOutline, settingsOutline, settingsSharp, createOutline, cameraOutline, trashOutline, barChartOutline, handRightOutline, enterOutline, helpCircle, helpCircleOutline, peopleCircleOutline, checkmarkCircleOutline, personRemove, personRemoveOutline, flashOff, flashOffOutline, enter, exit, exitOutline, cloudDone, cloudDoneOutline, personAddOutline, cloudOfflineOutline, cloudUploadOutline, peopleOutline, warningOutline, logOutOutline, downloadOutline, refreshOutline } from 'ionicons/icons';
import { VersionService } from '../Services/version.service';
import { IonMenuToggle, IonLabel, IonRouterOutlet, IonContent, IonSplitPane, IonList, IonMenu, IonListHeader, IonNote, IonBadge, IonItem, IonIcon, IonButton } from "@ionic/angular/standalone";
import { CurrentUserCardComponent } from "../Common/current-user-card/current-user-card.component";
import { AuthOpenIdService } from '../_Services/auth/auth-open-id-service';
import { PwaInstallService } from '../Services/pwa-install.service';

@Component({
  selector: 'app-app-dashboard',
  templateUrl: './app-dashboard.component.html',
  styleUrls: ['./app-dashboard.component.scss'],
  imports: [RouterLink, RouterLinkActive, IonMenuToggle, IonLabel, IonRouterOutlet, IonContent, IonSplitPane, IonList, IonMenu, IonListHeader, IonNote, IonBadge, IonItem, IonIcon, IonButton, CurrentUserCardComponent],
})
export class AppDashboardComponent  implements OnInit {

  private versionService = inject(VersionService);
  private authService = inject(AuthOpenIdService);
  protected pwaInstallService = inject(PwaInstallService);
  
  version = this.versionService.version;
  canInstall = this.pwaInstallService.canInstall;

  public appPages = [
    { title: 'Examens', url: '/dashboard/exams', icon: 'book' },
    { title: "Instellingen", url: '/dashboard/settings', icon: 'settings'}
  ];
  constructor() {
    addIcons({ bookOutline, bookSharp, book, lockClosed, 
              informationCircle, peopleCircle, eye, business, checkmarkCircle,
              documentOutline, add, barcodeOutline, listOutline, settingsOutline, 
              settingsSharp, createOutline, cameraOutline, trashOutline,barChartOutline,
              handRightOutline , enterOutline, helpCircle, helpCircleOutline, peopleCircleOutline,
              checkmarkCircleOutline, personRemove, personRemoveOutline,
              flashOff, flashOffOutline, enter, exit, exitOutline, cloudDone, cloudDoneOutline,
              personAddOutline, cloudOfflineOutline, cloudUploadOutline, peopleOutline, 
              warningOutline, logOutOutline, downloadOutline, refreshOutline });
  }

  ngOnInit() {}

  async logout() {
    await this.authService.logout();
  }

  async installApp() {
    await this.pwaInstallService.promptInstall();
  }

}
